module.exports = __webpack_public_path__ + "static/debit-card-4d878e775af222c274a6efad01737dbe.png";